import React from 'react';
import { connect } from 'react-redux';
import TextMap from '../../helpers/TextMap';

export default class BaseComponent extends React.Component {

  constructor(props) {
    super(props);

    // TODO: since most components inherit from this, we'll have hundreds of instances of TextMap floating around
    this.textMap = new TextMap();
    this.state = { mounted: false };

    // This binds all internal functions labled as "handler" to "this"
    
    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (name.toLowerCase().indexOf('handle') >= 0 && (this[name] instanceof Function)){
        this[name] = this[name].bind(this);
      }
    }

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  fixupMouse(event) {
    event = event || window.event;
    var e = {
      event: event,
      target: event.target ? event.target : event.srcElement,
      which: event.which ? event.which :
        event.button >= 0 ?
          event.button == 1 ? 1 :
            event.button == 2 ? 3 :
              event.button == 4 ? 2 : 1 :
          event.buttons,
      clientX: event.x ? event.x : event.clientX,
      clientY: event.y ? event.y : event.clientY,
    };
    return e;
  }

  handleResize() {
    this.resized = true;
    this.setState({ resized: !this.state.resized });
  }
  
  hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
  
  getChildInput(element) {
    const children = element.childNodes;
    if (children) {
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child.nodeName == 'INPUT' || child.nodeName == 'TEXTAREA') {
          return child;
        }
        else {
          const inputField = this.getChildInput(child);
          if (inputField) {
            return inputField;
          }
        }
      }
    }
  }

  mapTheChildren(element) {
    const children = element.childNodes;
    if (children) {
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (this.hasClass(child, 'field')) {
          let inputField = null;
          if (child.nodeName == 'INPUT' || child.nodeName == 'TEXTAREA') {
            inputField = child;
          }
          else {
            inputField = this.getChildInput(child);
          }
          if (inputField) {
            const self = this;
            inputField.addEventListener('focus', (e) => {
              self.handleSetFocus(e);
            });
            this.tabMap.push({ field: child, inputField: inputField });
          }
        }
        else {
          this.mapTheChildren(child);
        }
      }
    }
  }

  componentDidMount() {
    // Handle input fields if it is an input component.
    if (this && this.props.isDialog) {
      const element = document.getElementById(this.props.id);
      if (element) {
        this.initialized = true;
        const self = this;
        element.addEventListener('keydown', (e) => {
          self.handleKeyDown(e);
        });

        this.tabMap = [];
        this.currentField = 0;

        // Map the children input fields
        this.mapTheChildren(element);
        if (this.tabMap.length > 0) {
          this.currentField = 0;
          this.tabMap[this.currentField].inputField.focus();
          //this.tabMap[this.currentField].field.style.borderColor = "#CD030A"
        }
      }
    } 
    // window.addEventListener('resize', this.handleResize)
    this.setState({ mounted: true });
  }

  componentWillUnmount(){
    // this.setState({ mounted: false })
    // window.removeEventListener('resize', this.handleResize)
  }
  
  componentDidUpdate(prevProps) {
    // Handle input fields if it is an input component.
    if (this && prevProps && this.props.isDialog != prevProps.isDialog) {
      const element = document.getElementById(this.props.id);
      if (element) {
        if (!this.initialized) {
          this.initialized = true;
          const self = this;
          element.addEventListener('keydown', (e) => {
            self.handleKeyDown(e);
          });

          this.tabMap = [];
          this.currentField = 0;

          // Map the children input fields
          this.mapTheChildren(element);
          if (this.tabMap.length > 0) {
            this.currentField = 0;
            if (this.tabMap[this.currentField] && this.tabMap[this.currentField].inputField && this.tabMap[this.currentField].field) {
              this.tabMap[this.currentField].inputField.focus();
              //this.tabMap[this.currentField].field.style.borderColor = "#CD030A"
            }
          }
        }
        else {
          this.tabMap = [];
          // this.currentField = 0  keep the current field

          // Map the children input fields
          this.mapTheChildren(element);
          if (this.tabMap.length > 0) {
            // this.currentField = 0 keep the previous currentField
            if (this.currentField >= this.tabMap.length) {
              this.currentField = 0;
            }
            if (this.tabMap[this.currentField] && this.tabMap[this.currentField].inputField && this.tabMap[this.currentField].field){
              this.tabMap[this.currentField].inputField.focus();
              //this.tabMap[this.currentField].field.style.borderColor = "#CD030A"
            }
          }
        }
      }
    }
  }

  handleSetFocus(e) {
    let newField = -1;
    if (this.tabMap) {
      this.tabMap.filter((tm, index) => {
        if (tm.inputField == e.target) {
          newField = index;
          return true;
        }
        else {
          return false;
        }
      });
      if (newField >= 0 && newField != this.currentField && this.tabMap[this.currentField]) {
        this.tabMap[this.currentField].field.style.borderColor = '#B8B8B8';
        this.currentField = newField;
        //this.tabMap[this.currentField].field.style.borderColor = "#CD030A"
      }
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 9) {
      e.preventDefault();
      this.tabMap[this.currentField].field.style.borderColor = '#B8B8B8';

      if (e.shiftKey) {
        this.currentField--;
        if (this.currentField < 0) {
          this.currentField = this.tabMap.length - 1;
        }
      }
      else {
        this.currentField++;
        if (this.currentField >= this.tabMap.length) {
          this.currentField = 0;
        }        
      }
      this.tabMap[this.currentField].inputField.focus();
      //this.tabMap[this.currentField].field.style.borderColor = "#CD030A"
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return{
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {};
};

connect(mapStateToProps, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/baseClasses/BaseComponent/index.js